import * as React from 'react'

export const LightGreyBadge = ({ className, children }: { className: string; children: React.ReactNode }) => {
  const classes = `inline-block px-2 py-1 text-xs text-center text-gray-500 bg-gray-100 rounded-lg ${className}`
  return <span className={classes}>{children}</span>
}
